import * as url from "../url.helper";

import { post } from "../api.helper";

export const getAllNotifications = data => post(url.GET_ALL_NOTIFICATION, data);

export const getAllReadNotifications = data => post(url.GET_READ_NOTIFICATION, data);

export const getAllUnReadNotifications = data => post(url.GET_UNREAD_NOTIFICATION, data);

export const updateMarkAsRead = data => post(url.UPDATE_MARK_READ, data);

export const updateMarkAllAsRead = data => post(url.UPDATE_MARKALL_READ, data);




